import { useCallback, useState } from 'react';
import { useMagic } from '@package/smart-wallet/providers';
import * as Sentry from '@sentry/react';

export const useRecoveryKeys = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { magic } = useMagic();

  /* Callbacks */
  const handleExportKey = useCallback(async () => {
    setIsLoading(true);
    try {
      await magic?.user.revealEVMPrivateKey();
    } catch (error: any) {
      console.error(`Error exporting keys: ${error}`);
      setError(`Error exporting keys: ${error?.response?.data?.msg}`);
      Sentry.captureException({
        message: 'Error exporting keys',
        extra: {
          error,
        },
      });
    } finally {
      setIsLoading(false);
    }
  }, [magic]);

  /* Return */
  return {
    error,
    isLoading,
    handleExportKey,
  };
};
